import { View } from 'es6/components/view'

/**
 * Вид пользователя
 */

export class UserView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.listenTo(this.settlement, 'change:settlement_id', this.updateUserSettlementInfo)
  }
  /**
   * Обновляет город пользователя
   * @param {SettlementForm} model
   */
  updateUserSettlementInfo (model) {
    this.user.set('settlement_id', model.get('settlement_id'))
  }
}
